import React from 'react'

export const Separador = () => {
  return (
    <div>
        <div className="text-center-top p-4">
            <h2 style={{color:"white"}} className="p-3 mb-0 text-center fw-bold text-light titulos animate__animated animate__pulse">Manjares</h2>
        </div>
    </div>
  )
}
